import { Alert, AlertIcon, AlertTitle } from "@/components/elements/Alert";

export function SkippedFeaturesAlert(props: {
  destinationLabel: string;
  warnings: string[];
}) {
  if (props.warnings.length === 0) {
    return null;
  }
  return (
    <Alert status="warning" className="items-start">
      <AlertIcon className="mt-0.5" />
      <div>
        <AlertTitle className="mb-1">
          Some settings don&apos;t apply in {props.destinationLabel}
        </AlertTitle>
        <ul className="list-disc pl-4 text-sm">
          {props.warnings.map((warning) => (
            <li key={warning}>{warning}</li>
          ))}
        </ul>
      </div>
    </Alert>
  );
}
